export default "__VITE_ASSET__CXBTraBP__"